/**
 * Hlavní fotka z galerie (vize podnety-tymu-2026-10, F7.12; řez 05, Kontrakt bod 3): fotka
 * zvolená v galerii se stane hlavní fotkou téhož formuláře a galerie se podle pravidel
 * AK20–AK22 srovná. Volá ji jen `MediaPicker` (`pickerField`; `SortableThumb` dostává hotové
 * zpětné volání), a to jednou nad `value` a `primary.value` před prvním setterem (po
 * `onChange(gallery)` by G v galerii už nebyla).
 *
 * Pravidla:
 * - dosavadní hlavní P zaujme místo zvolené G (první výskyt G), „jen se prohodí“;
 * - P, která už v galerii byla, odejde ze svého dřívějšího místa (výklad F7.12 ve
 *   `docs/vize-spory.md`, záznam řezu 05 architekta); bez hlavní fotky G z galerie jen odejde;
 * - žádné ID není ve výsledné galerii dvakrát; vstup se nemutuje (hodnota pole z RHF).
 * Zvolená fotka, která už hlavní je nebo v galerii není, nic nemění (akce se kreslí jen u fotek
 * galerie; větev je pojistka).
 */
export function setGalleryPrimary(
  gallery: readonly string[],
  primary: string | null,
  picked: string,
): { gallery: string[]; primary: string } {
  if (picked === primary || !gallery.includes(picked)) {
    return { gallery: [...gallery], primary: primary ?? picked };
  }
  const out: string[] = [];
  const seen = new Set<string>();
  let placed = false;
  for (const id of gallery) {
    if (id === picked) {
      if (!placed && primary !== null && !seen.has(primary)) {
        out.push(primary);
        seen.add(primary);
      }
      placed = true;
      continue;
    }
    if (id === primary || seen.has(id)) continue;
    out.push(id);
    seen.add(id);
  }
  return { gallery: out, primary: picked };
}
